export default "__VITE_ASSET__YKnXtZu1__"